<template>
  <div :style="'height:'+screenHeight+'px;'">
    <img src="../assets/pantalla/mobi.jpg" :style="'width: 100%; height: '+screenHeight+'px;'">
    <!-- <iframe :src="url"
      :style="'width: 100%; height: '+screenHeight+'px;'"
      frameborder="0"
      allowfullscreen>
    </iframe> -->
    <img>
  </div>
</template>
<script>

export default {
  name: "KPIScreen",
  data() {
    return {
      plugins: [],
      screenHeight:window.innerHeight-60,
      screenWidth:window.innerWidth,
      cont:0,
      //url: "https://canplast.com.mx",
      url: "https://app.klipfolio.com/published/d4df7343fc1701263f8aa5f7012e0bb9/dashboard-mquinas-de-produccin-cortadoras",
      urls: [
        "https://app.klipfolio.com/published/d4df7343fc1701263f8aa5f7012e0bb9/dashboard-mquinas-de-produccin-cortadoras",
        "https://app.klipfolio.com/published/10c6d3c2431fdfd71eb1881e47143c56/dashboard-mquinas-de-produccin-engomadoras",
        "https://app.klipfolio.com/published/fcb2aa8cffe0a61d6458b6ba52753f83/dashboard-mquinas-de-produccin-contadoras"
      ]
    };
  },
  mounted(){
    this.screenHeight = window.innerHeight
    this.screenWidth = window.innerWidth
    setInterval(() => {
      if(this.cont == this.urls.length){
        this.cont = 0;
      }
      this.url = this.urls[this.cont]
      this.cont = this.cont+1
    }, 70000);
  },
};
</script>
<style>
</style>
